import { StaticQuery, graphql, Link } from 'gatsby';
import React from 'react';
import logoBlack from "../images/logo-black.svg";

const Header = () => (
    <StaticQuery
        query={graphql`
            query {
                wordpressWpApiMenusMenusItems(name: {eq: "Menu"}) {
                    items {
                    title
                    url
                }
            }
        }
    `}
        render={data => (
            <>
                <div className="navbar-items">

                    <Link className="navbar-item" to="/">
                        <img
                            src={logoBlack}
                            alt="Next and Co"
                            style={{ height: "11px" }}
                        />
                    </Link>
                </div>
            </>
        )}
    />
);
export default Header;
